import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { eventNames } from 'process';

@Component({
  selector: 'app-select-filter',
  templateUrl: './select-filter.component.html',
  styleUrls: ['./select-filter.component.scss']
})


export class SelectFilterComponent implements OnInit, OnChanges {
  @Input() label!: string;
  @Input() formName!: string;
  @Input() selectedOption!: string;
  @Input() filters: string[] = [];
  @Output() changeCheck: EventEmitter<any> = new EventEmitter<any>();

  filterText: string = '';
  filtered: string[] = [];
  showDropdown: boolean = false;

  constructor(private eRef: ElementRef) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filters'] && this.filters) {
      this.filtered = this.filters;
    }
    
  }

  filterSections() {
    this.filtered = this.filters.filter(n =>
      n.toLowerCase().includes(this.filterText.toLowerCase())
    );
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  selectOption(option: string, event: Event) {
    event.stopPropagation(); // Evita que se cierre antes de tiempo
    this.selectedOption = option;
    this.filterText='';
    this.showDropdown = false;
    this.changeCheck.emit({ name: this.formName, value: option });
  }

  @HostListener('document:click', ['$event'])
  closeIfClickedOutside(event: Event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.showDropdown = false;
    }
  }
  clear(){
    this.selectedOption=null;
    event.stopPropagation(); 
    this.filterText='';
    this.showDropdown = false;
    this.changeCheck.emit({ name: this.formName, value: null });

  }
}